import { useState, useEffect } from 'react'
import { genericEntityService } from '../../../services/genericEntityService'
import { refresherSignal } from '../menu/refresher-signal'

export const useGenericEntityMenu = () => {
    const [entities, setEntities] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const loadMenu = async () => {
        try {
            setLoading(true)
            const response = await genericEntityService.getMenuOptions()
            const data = response.data

            const entityMenus = data
                .filter(item => {
                    return item.MenuContents?.some(c => c.Type === 'EntityList')
                })
                .map(item => ({
                    subMenuLabel: item.EntityCode,
                    subMenuDisplay: item.Captions?.en || item.Captions?.pt || item.EntityCode,
                    tableName: `GENERICENTITY_${item.EntityCode}`,
                    subMenuUrl: `genericentity/entity/${item.EntityId}`,
                    subSubMenus: [],
                    _captions: item.Captions || {},
                    _entityId: item.EntityId
                }))
            
            setEntities(entityMenus)
            setError(null)
        } catch (err) {
            setError(err)
            setEntities([])
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        loadMenu()
    }, [])

    useEffect(() => {
        const unsubscribe = refresherSignal.subscribe((value) => {
            if (value === true || value?.type === 'menu-refresh') {
                setLoading(true)
                loadMenu()
            }
        })

        return () => unsubscribe()
    }, [])

    const refreshMenu = () => {
        setLoading(true)
        loadMenu()
    }

    return {
        entities,
        loading,
        error,
        refreshMenu
    }
}
